function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gay_svg__clip0_1_39)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.072 12.602l-1.246 1.252 1.197 1.202 1.998-2.007 2.951 2.963 1.136-1.14-2.95-2.964 1.972-1.98-1.197-1.204-1.343 1.349-1.283-1.288L3.465.909 1.113.199C.496.011.129.358.297.992l.65 2.445 7.842 7.876 1.283 1.288zm-3.631.136l1.246 1.253-1.196 1.202-2-2.008-2.95 2.963-1.137-1.141 2.951-2.963-1.972-1.98L2.58 8.86l1.343 1.349 1.282-1.288 2.518 2.529-1.282 1.287zm5.025-5.047l4.1-4.116.65-2.446c.166-.625-.196-.981-.816-.794l-2.351.71-4.1 4.118 2.517 2.528z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gay_svg__clip0_1_39"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgGay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgGay;